export const BRIDGE_SITE_PATH_LIST = [
  "/about",
  "/promotions",
  "/news",
  "/vip",
  "/support",
  "/sports",
  "/auth",
  "/id",
  "/user",
  "/clubhouse",
  "/help-centre",
];
